"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentSavedView = void 0;
var _react = require("react");
var _main = require("../../../main");
var _hooks = require("../../../hooks");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _jsxRuntime = require("react/jsx-runtime");
var EnvironmentSavedView = function EnvironmentSavedView(props) {
  var mode = props.mode,
    environmentTitle = props.environmentTitle,
    onCloseAfterSave = props.onCloseAfterSave;
  var _useContext = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext),
    userSessionData = _useContext.userSessionData,
    environmentData = _useContext.environmentData,
    getLabel = _useContext.getLabel,
    resetEnvironment = _useContext.resetEnvironment,
    setSliderView = _useContext.setSliderView;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var savedEnvironmentTitle = (0, _react.useRef)(environmentTitle);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": "environmentSavedView",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Header, {
      messageIcon: "Checkmark",
      messageType: "success",
      message: getLabel(mode === 'updated' ? 'environment_updated' : 'environment_created'),
      subTitle: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: environmentTitle ? environmentTitle : savedEnvironmentTitle.current
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Tooltip, {
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
            id: "environmentShareButton",
            view: "alternate",
            shape: "round",
            size: "large",
            onClick: function onClick() {
              setSliderView('share');
            },
            category: "assignActivity",
            label: "shareActivity",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Icon, {
              name: "Share",
              width: "24",
              height: "24"
            })
          }),
          children: isMobileView ? '' : getLabel('share_Tooltip')
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: mode === 'updated' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
          children: getLabel('environment_ready_for_work')
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: getLabel('environment_invite_class')
          })
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_main.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          view: "outlined",
          id: mode === 'updated' ? 'updateAnotherEnvironmentButton' : 'createAnotherEnvironmentButton',
          onClick: function onClick() {
            savedEnvironmentTitle.current = environmentTitle;
            resetEnvironment();
            setSliderView('main');
          },
          children: getLabel(mode === 'updated' ? 'update_another_environment' : 'create_another_environment')
        })
      }), userSessionData.role !== 'admin' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          view: "contained",
          id: "startWorkOnEnvironmentButton",
          onClick: function onClick() {
            onCloseAfterSave(environmentData);
          },
          children: getLabel('start_work_on_environment')
        })
      })]
    })]
  });
};
exports.EnvironmentSavedView = EnvironmentSavedView;